---
title: Light as architecture
date: 2026-04-20
author: Brian Ellison
category: Craft
excerpt: Electric light should never be the subject of the room — but it should know exactly what is.
placeholder: true
---

The most common mistake in lit interiors is treating the fixtures as **decor**.

Pendants and sconces and floor lamps get specified the way one specifies a vase: as objects with a look. But the light they cast — the actual physical light — is treated as an afterthought, dim or bright depending on what comes with the fixture.

We treat it the other way around.

## The plan first

Every project starts with a light plan, drawn before the floor plan is finalized. Where will the morning sun fall? Where does it pool at 4pm in November? What corner needs help at 9pm in February? These questions answer themselves with directional light, layered light, and concealed light long before any fixture is chosen.

## Fixtures last

When the plan is solid, we choose fixtures the way you'd choose a frame for a painting. Quiet, considered, present without insisting. The fixture is the frame; the **cast light** is the painting.

## Dimmers everywhere

Every interior we touch gets dimmers on every circuit. Most rooms run at 30–60% by default. Brightness is something you choose; it's not the default state of the room.

*A practice note. More to follow.*
